import { render, staticRenderFns } from "./pending.vue?vue&type=template&id=fec2287a&scoped=true&"
import script from "./pending.vue?vue&type=script&lang=js&"
export * from "./pending.vue?vue&type=script&lang=js&"
import style0 from "./pending.vue?vue&type=style&index=0&id=fec2287a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec2287a",
  null
  
)

export default component.exports